import { Box, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { fresh } from "../../hooks/use-map-theme-styles";
import { BaseAgreement } from "../../models/generated/graphql";
import { flexibleFormRelatedAgreements } from "../../store/flexible";
import { userPersonalInfoState } from "../../store/user";

export function AgreementAllocation() {
	const agreementsData = useRecoilValue(flexibleFormRelatedAgreements);
	const styles = useStyles();
	const { t } = useTranslation();
	const user = useRecoilValue(userPersonalInfoState);

	function formatCounterparties(agreement: BaseAgreement) {
		return agreement.counterpartiesConnection.edges
			.map((counterparty) => counterparty.node.name)
			.filter((name) => name !== user.organization.name)
			.join(", ");
	}

	return (
		<table className={styles.table}>
			<colgroup>
				<col span={4} className={styles.col}></col>
			</colgroup>
			<thead className={styles.tableHeader}>
				<tr>
					<th>{t("agreement-id")}</th>
					<th>{t("agreement-name")}</th>
					<th>{t("agreement-tag")}</th>
					<th>{t("agreement-counterparty")}</th>
				</tr>
			</thead>
			<tbody className={styles.tableBody}>
				{!!agreementsData.data?.length &&
					agreementsData.data?.map(({ agreement }, index) => (
						<tr key={index}>
							<td>{agreement.initialVersionId}</td>
							<td>{agreement.name}</td>
							<td>
								<Box display="flex">
									{agreement.tags.map((tag, ti) => (
										<Box key={ti} style={{ backgroundColor: fresh, borderRadius: "10px" }} paddingX={1}>
											{tag.name}
										</Box>
									))}
								</Box>
							</td>
							<td>{formatCounterparties(agreement)}</td>
						</tr>
					))}
				{agreementsData.data && !agreementsData.data?.length && (
					<tr>
						<td colSpan={4} style={{ textAlign: "center" }}>
							<Typography variant="body1" style={{ fontWeight: "bold" }}>
								{t("no-matching-agreement-to-display")}
							</Typography>
						</td>
					</tr>
				)}
			</tbody>
		</table>
	);
}

const useStyles = makeStyles(() => ({
	col: {
		width: "25%",
	},
	table: {
		width: "100%",
		padding: "0 32px",
		"& th": {
			padding: "10px 0 10px 0",
		},
		"& td": {
			padding: "10px 0 10px 0",
		},
	},
	tableHeader: {
		fontSize: "16px",
		fontWeight: 600,
		"& th": {
			textAlign: "left",
		},
	},
	tableBody: {
		fontSize: "14px",
	},
}));
